export default function isPasswordValid(input: string): boolean {
	const minLenght = 8;
	const maxLenght = 64;

	return input.length >= minLenght && input.length <= maxLenght;
}
